import { IconCheckOutline18 as Check } from "nucleo-ui-outline-18"

import type { RoadmapSource } from "@productlane/zero/queries"
import { cn } from "@productlane/lib/src/browser"
import { CommandItem } from "@productlane/ui/src/components/internal/command"

import type { SharedFilterItemsProps } from "./types"
import { useRoadmapFilterState } from "../roadmap-filter-state"

export const ROADMAP_SOURCE_OPTIONS: Array<{
	value: RoadmapSource
	label: string
	description: string
}> = [
	{
		value: "customers",
		label: "Customers",
		description: "At least one customer request",
	},
	{ value: "internal", label: "Internal", description: "No customer requests" },
]

export const ROADMAP_SOURCE_LABELS: Record<RoadmapSource, string> = {
	customers: "Customers",
	internal: "Internal",
}

export function SourceFilterItems({ onSelect }: SharedFilterItemsProps) {
	const { sources, toggleSource } = useRoadmapFilterState()

	return (
		<>
			{ROADMAP_SOURCE_OPTIONS.map((option) => {
				const isSelected = sources.includes(option.value)
				return (
					<CommandItem
						key={option.value}
						value={option.label}
						onSelect={() => {
							toggleSource(option.value)
							onSelect()
						}}
					>
						<div className="flex w-full items-center gap-2">
							<div className="flex min-w-0 flex-1 flex-col">
								<span className="truncate">{option.label}</span>
								<span className="truncate text-xs text-secondary">
									{option.description}
								</span>
							</div>
							<Check
								className={cn("h-4 w-4 shrink-0", {
									"opacity-100": isSelected,
									"opacity-0": !isSelected,
								})}
							/>
						</div>
					</CommandItem>
				)
			})}
		</>
	)
}
